import script from "./ModalMargin.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMargin.vue?vue&type=script&setup=true&lang=js"

import "./ModalMargin.vue?vue&type=style&index=0&id=d21e86ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d21e86ea"]])

export default __exports__